/**
 * URL for files in `public/` (supports CRA `homepage` via PUBLIC_URL).
 * @param {string} path absolute path from site root, e.g. '/hero.svg'
 */
export function publicAsset(path) {
  const base = process.env.PUBLIC_URL || '';
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
